function applyButtonFix() {
    const cpbButton = document.querySelector('#product-builder .cpb-add-to-cart-button');
    const targetButton = document.querySelector('.personalize-it--js');
    
    if (!cpbButton || !targetButton) return false;
    
    cpbButton.className = targetButton.className;
    
    cpbButton.innerHTML = 'ADD TO CART';
    
    const container = cpbButton.closest('.cpb-product-actions-container');
    if (container) {
        container.className = 'product-form__buttons';
        container.style.cssText = 'display: initial;';
    }

    return true;
}

function applyTextFix() {
    const title = document.querySelector('.swal2-title');
    const content = document.querySelector('.swal2-html-container');
    const okButton = document.querySelector('.swal2-confirm');

    if (title && title.textContent === 'Product Incomplete') {
        title.textContent = 'Just a little more info needed!';
        title.classList.add('error-title');
    }
    
    if (content && content.innerHTML.includes('You need to select all required categories to continue. Please select the following categories: ')) {
        content.innerHTML = content.innerHTML.replace(
            'You need to select all required categories to continue. Please select the following categories: ', 
            'Please fill in the required fields so Santa can make this letter perfect.'
        );
    }

    if (okButton && okButton.innerHTML.includes('OK')) {
        okButton.innerHTML = okButton.innerHTML.replace(
            'OK',
            'Got it, thanks!'
        )
    }
    
    return true;
}

function applyFixes() {
    applyButtonFix();
    applyTextFix();
}

document.addEventListener('DOMContentLoaded', function() {
    applyFixes();
});

const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
            applyFixes();
        }
    });
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});

setInterval(applyTextFix, 100);